import { SearchAndSelectEntry } from "@kaltura/mediaspace-shared-types";

// ----------------------------------------------------------------
// common predicates for use with media table's ConditionalMessages
// ----------------------------------------------------------------

/**
 * return true if entry not ready for publish and no reasons (bwcompat) or reasons contains "fill_out_required_fields"
 * @param entry
 */
export const missingRequiredFieldsPredicate = (entry: SearchAndSelectEntry) => {
    // show message if entry not ready for publish with no reason (bw-compat) or reason is "fill_out_required_fields"
    return (
        // on channel search we don't add readyForPublish, so "no info" means "ready for publish".
        !(entry.readyForPublish ?? true)
        && (
            !entry.notReadyForPublishNotificationGroups
            || entry.notReadyForPublishNotificationGroups.includes("fill_out_required_fields")
        )
    );
};

/**
 * return true if entry not ready for publish and reasons contains "captions"
 * @param entry
 */
export const missingCaptionsPredicate = (entry: SearchAndSelectEntry) =>
    // on channel search we don't add readyForPublish, so "no info" means "ready for publish".
    !(entry.readyForPublish ?? true) && entry.notReadyForPublishNotificationGroups?.includes("captions");
